import { IProduct, ITelevision } from "../../fetchOrderProducts";

export function isTelevision(product: IProduct): product is ITelevision {
  return (
    "specificationId" in product && product.specificationId === "TELEVISION"
  );
}
